import { Card, Badge, Table, Row, Col, Typography } from "antd"
import { UserOutlined, CheckCircleOutlined, CloseCircleOutlined, FileDoneOutlined, FileExclamationOutlined, FolderOpenOutlined } from "@ant-design/icons"
import ExportarDetalleProyecto from "./ExportarDetalleProyecto" // Ajusta la ruta según tu estructura

const { Column } = Table
const { Title } = Typography

export default function DetalleProyectoModal({ nombreProyecto, participantes, onClose }) {
  const participantesConArchivos = participantes.filter(p => p.tiene_archivos)
  const participantesSinArchivos = participantes.filter(p => !p.tiene_archivos)
  
  const getTotalArchivos = (participante) => {
    if (!participante.resultados || Object.keys(participante.resultados).length === 0) return 0
    return Object.values(participante.resultados).reduce((sum, proyecto) => {
      return sum + (proyecto.total || 0)
    }, 0)
  }

  const calcularPorcentaje = (valor, total) => {
    if (!total || total === 0) return 0
    return Math.round((valor / total) * 100)
  }

  const totalParticipantes = participantes.length
  const totalArchivos = participantes.reduce((acc, p) => acc + getTotalArchivos(p), 0)

  return (
    <div className="space-y-6">
      <div className="flex justify-between items-center mb-4">
        <div>
          <h2 className="text-2xl font-semibold">{nombreProyecto}</h2>
        </div>
        <ExportarDetalleProyecto
          nombreProyecto={nombreProyecto}
          participantes={participantes}
          participantesConArchivos={participantesConArchivos}
          participantesSinArchivos={participantesSinArchivos}
          totalParticipantes={totalParticipantes}
          totalArchivos={totalArchivos}
        />
      </div>
      
      <Row
        gutter={[16, 16]}
        justify="center"
        style={{ marginTop: 14, marginBottom: 14 }}
      >
        <Col xs={24} sm={12} md={6}>
          <Card bordered hoverable style={{ height: 100, padding: 15 }}>
            <div className="flex flex-col justify-center items-center h-full text-center space-y-1">
              <UserOutlined style={{ fontSize: 22 }} />
              <Title level={5} style={{ margin: 0 }}>Total Participantes</Title>
              <p className="text-lg font-bold">{totalParticipantes}</p>
            </div>
          </Card>
        </Col>

        <Col xs={24} sm={12} md={6}>
          <Card bordered hoverable style={{ height: 100, padding: 15 }}>
            <div className="flex flex-col justify-center items-center h-full text-center space-y-1">
              <FileDoneOutlined style={{ fontSize: 22, color: "#10b981" }} />
              <Title level={5} style={{ margin: 0 }}>Participantes con al menos una visita</Title>
              <p className="text-lg font-bold text-green-600">
                {participantesConArchivos.length} ({calcularPorcentaje(participantesConArchivos.length, totalParticipantes)}%)
              </p>
            </div>
          </Card>
        </Col>

        <Col xs={24} sm={12} md={6}>
          <Card bordered hoverable style={{ height: 100, padding: 15 }}>
            <div className="flex flex-col justify-center items-center h-full text-center space-y-1">
              <FileExclamationOutlined style={{ fontSize: 22, color: "#ef4444" }} />
              <Title level={5} style={{ margin: 0 }}>Participantes sin visitas registradas</Title>
              <p className="text-lg font-bold text-red-600">
                {participantesSinArchivos.length} ({calcularPorcentaje(participantesSinArchivos.length, totalParticipantes)}%)
              </p>
            </div>
          </Card>
        </Col>
        <Col xs={24} sm={12} md={6}>
          <Card bordered hoverable style={{ height: 100, padding: 15 }}>
            <div className="flex flex-col justify-center items-center h-full text-center space-y-1">
              <FolderOpenOutlined style={{ fontSize: 22 }} />
              <Title level={5} style={{ margin: 0 }}>Total visitas</Title>
              <p className="text-lg font-bold">{totalArchivos}</p>
            </div>
          </Card>
        </Col>
      </Row>
      
      <Row gutter={[16, 16]} justify="center">
        <Col xs={24} md={12}>
          <Card
            title={
              <div style={{ display: 'flex', alignItems: 'center', gap: '16px' }}>
                <CheckCircleOutlined style={{ color: 'green' }} />
                <span>Participantes con visitas realizadas ({participantesConArchivos.length})</span>
              </div>
            }
            hoverable
          >
            <div className="overflow-auto">
              <Table
                size="middle"
                pagination={false}
                scroll={{ y: 300, x: "100%" }}
                dataSource={participantesConArchivos}
                rowKey="oid"
              >
                <Column
                  title="#"
                  key="index"
                  render={(_, __, index) => index + 1}
                  width={50}
                />
                <Column title="Nombre" dataIndex="nombre" key="nombre" />
                <Column title="Cédula" dataIndex="cedula" key="cedula" />
                <Column title="Municipio" dataIndex="municipio" key="municipio" />
                <Column
                  title="Total visitas"
                  key="totalArchivos"
                  align="center"
                  render={(_, record) => (
                    <Badge count={getTotalArchivos(record)} style={{ backgroundColor: "#1890ff" }} />
                  )}
                />
              </Table>
            </div>
            {participantesConArchivos.length === 0 && (
              <div className="text-center text-gray-400 py-4">
                No hay participantes con archivos en este proyecto.
              </div>
            )}
          </Card>
        </Col>

        <Col xs={24} md={12}>
          <Card
            title={
              <div style={{ display: 'flex', alignItems: 'center', gap: '16px' }}>
                <CloseCircleOutlined style={{ color: "red" }} />
                <span>Participantes sin visitas realizadas ({participantesSinArchivos.length})</span>
              </div>
            }
            hoverable
          >
            <div className="overflow-auto">
              <Table
                size="middle"
                pagination={false}
                scroll={{ y: 300, x: "100%" }}
                dataSource={participantesSinArchivos}
                rowKey="oid"
              >
                <Column
                  title="#"
                  key="index"
                  render={(_, __, index) => index + 1}
                  width={50}
                />
                <Column title="Nombre" dataIndex="nombre" key="nombre" />
                <Column title="Cédula" dataIndex="cedula" key="cedula" />
                <Column title="Municipio" dataIndex="municipio" key="municipio" />
                <Column
                  title="Estado"
                  key="estado"
                  align="center"
                  render={() => <Badge status="error" text="Sin archivos" />}
                />
              </Table>
            </div>
            {participantesSinArchivos.length === 0 && (
              <div className="text-center text-gray-400 py-4">
                Todos los participantes tienen archivos en este proyecto.
              </div>
            )}
          </Card>
        </Col>
      </Row>
    </div>
  )
}